export const SET_WEBSITE_STYLES = 'SET_WEBSITE_STYLES'
export const UPDATE_WEBSITE_STYLES_TYPOGRAPHY_PARAGRAPH =
  'UPDATE_WEBSITE_STYLES_TYPOGRAPHY_PARAGRAPH'
export const UPDATE_WEBSITE_STYLES_TYPOGRAPHY_HEADING =
  'UPDATE_WEBSITE_STYLES_TYPOGRAPHY_HEADING'
export const UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_TYPOGRAPHY =
  'UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_TYPOGRAPHY'
export const UPDATE_WEBSITE_STYLES_SECONDARY_BUTTONS_TYPOGRAPHY =
  'UPDATE_WEBSITE_STYLES_SECONDARY_BUTTONS_TYPOGRAPHY'
export const UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_BORDER =
  'UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS_BORDER'
export const UPDATE_WEBSITE_STYLES_SECONDARY_BUTTONS_BORDER =
  'UPDATE_WEBSITE_STYLES_SECONDARY_BUTTONS_BORDER'
export const SET_WEBSITE_NAME = 'SET_WEBSITE_NAME'
export const SET_CURRENT_WEBSITE_LOCALE = 'SET_CURRENT_WEBSITE_LOCALE'
export const SET_WEBSITE_LOCALE = 'SET_WEBSITE_LOCALE'
export const SET_WEBSITE_LOCALES = 'SET_WEBSITE_LOCALES'
export const ADD_WEBSITE_LAYOUT = 'ADD_WEBSITE_LAYOUT'
export const SET_WEBSITE_LAYOUT_BY_LOCALE = 'SET_WEBSITE_LAYOUT_BY_LOCALE'
export const REMOVE_WEBSITE_LAYOUT = 'REMOVE_WEBSITE_LAYOUT'
export const SET_WEBSITE_THEMES_LIST = 'SET_WEBSITE_THEMES_LIST'
export const SET_WEBSITE_THEME = 'SET_WEBSITE_THEME'
export const SET_WEBSITE_DRAFT_THEME = 'SET_WEBSITE_DRAFT_THEME'
export const SET_WEBSITE_SETTINGS = 'SET_WEBSITE_SETTINGS'
export const UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS =
  'UPDATE_WEBSITE_STYLES_PRIMARY_BUTTONS'
export const UPDATE_WEBSITE_STYLES_SECONDARY_BUTTONS =
  'UPDATE_WEBSITE_STYLES_SECONDARY_BUTTONS'

export const UPDATE_WEBSITE_STYLES_FORM_FIELD =
  'UPDATE_WEBSITE_STYLES_FORM_FIELD'

export const UPDATE_WEBSITE_STYLES_FORM_FIELD_TYPOGRAPHY =
  'UPDATE_WEBSITE_STYLES_FORM_FIELD_TYPOGRAPHY'

export const UPDATE_WEBSITE_STYLES_FORM_FIELD_BORDER =
  'UPDATE_WEBSITE_STYLES_FORM_FIELD_BORDER'

export const UPDATE_WEBSITE_THEME_LINKS = 'UPDATE_WEBSITE_THEME_LINKS'

export const UPDATE_WEBSITE_STYLES_LAYOUT_SETTINGS =
  'UPDATE_WEBSITE_STYLES_LAYOUT_SETTINGS'
